import React from 'react';
import {FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import MatchGroupCard from './match_group_card';
import {confirmedCount} from './resolution_state';

/**
 * The T4-135 review step: every ambiguous match the preview found, one card each.
 *
 * Presentational. The container owns the selection, so BACK can return to the contact list with
 * the user's ticks - and their resolutions - intact.
 *
 * The counter lives here rather than in the modal footer because GenericModal renders only its
 * buttons there, and it is used by dozens of other modals that should not grow a prop for this.
 *
 * It counts cards reviewed, not contacts to import - a different question from the button's, and
 * deliberately worded so the two cannot be read as the same number. It shares `isGroupResolved`
 * with the card badge, so a card showing RESOLVED always counts, including one where every client
 * was declined.
 */
const XeroMatchReviewStep = ({groups, autoLinkCount, selectedCount, selection, onSelect}) => (
	<div className="integration-sync-clients-modal-content xero-match-review">
		<div className="integration-sync-clients-modal-description">
			<FormattedMessage id="integrations.xero.match_review.description" values={{total: selectedCount}} />
		</div>
		{autoLinkCount > 0 ? (
			<div className="xero-match-banner">
				<FormattedMessage id="integrations.xero.match_review.auto_linked" values={{count: autoLinkCount}} />
			</div>
		) : null}
		<CustomScrollDiv autoHeight autoHeightMin={10} autoHeightMax={'45vh'}>
			{groups.map(group => (
				<MatchGroupCard key={group.email} group={group} selection={selection} onSelect={onSelect} />
			))}
		</CustomScrollDiv>
		<div className="xero-match-confirmed-count">
			<FormattedMessage
				id="integrations.xero.match_review.confirmed_count"
				values={{confirmed: confirmedCount(groups, selection), total: groups.length}}
			/>
		</div>
	</div>
);

export default XeroMatchReviewStep;
